import React from "react";

export default function Introduction() {
  return (
    <section id="introduction" className="section">
      <div className="container">
        <h2 className="title is-2">Présentation</h2>

        <div className="columns">
          <div className="column">
            <strong className="has-text-danger">Problème</strong>
            <p>
              Les données nutritionnelles sont souvent écrites en petit sur les
              emballages et il n'est pas toujours évident de bien les comprendre
              et de s'en souvenir.
            </p>
          </div>
          <div className="column">
            <strong className="has-text-success">Solution</strong>
            <p>
              L'application Yakoi a été développée pour aider les consommateurs
              à mieux comprendre leur alimentation et faire le bon choix.
            </p>
          </div>
          <div className="column">
            <strong className="has-text-primary">L'équipe</strong>
            <p>
              Yakoi est une application mobile développé dans le cadre d'un
              projet universitaire par: Amine HAMOUDI, Sanaï MANSOUR, Rudro KHAN
              et Safâa TALHAOUI.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
